import { Injectable, Renderer2, RendererFactory2, TemplateRef, ViewContainerRef } from "@angular/core";
import { DialogCloseResult, DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { Observable, firstValueFrom, map } from 'rxjs';
import { PrimeNGConfig } from "primeng/api";
export enum ConfirmationDialogResult {
    Ok,
    No,
    Cancel
};

@Injectable({
    providedIn: 'root'
})
export class ConfirmationDialogService {
    yesLabel: string;
    noLabel: string;
    cancelLabel: string;
    actions: any[];

    private dialogRef: DialogRef | null = null;
    private renderer: Renderer2;
    private clickListener: (() => void) | null = null; // Store the listener reference

    constructor(
        private primengConfig: PrimeNGConfig, private dialogService: DialogService,
        private rendererFactory: RendererFactory2
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);

        this.yesLabel = this.primengConfig.getTranslation('common.yes');
        this.noLabel = this.primengConfig.getTranslation('common.no');
        this.cancelLabel = this.primengConfig.getTranslation('common.cancel');

        this.actions = [
            { text: this.yesLabel, themeColor: "primary", dialogResult: ConfirmationDialogResult.Ok },
            { text: this.noLabel, dialogResult: ConfirmationDialogResult.No },
            { text: this.cancelLabel, dialogResult: ConfirmationDialogResult.Cancel }
        ];
    }

    openDialog(title: string, body: string | TemplateRef<any>, cancelButtonVisible = true, danger = false, appendTo: ViewContainerRef = undefined): Promise<ConfirmationDialogResult> {

        this.dialogRef = this.dialogService.open({
            title: title,
            appendTo: appendTo,
            content: body,
            actions: cancelButtonVisible ? this.actions : this.actions.filter(x => !(x.dialogResult == ConfirmationDialogResult.Cancel)),
            width: 450, height: 200, minWidth: 250, actionsLayout: 'end'
        });

        if (danger)
            this.dialogRef.dialog.location.nativeElement.classList.add('k-danger');

        setTimeout(() => {
            this.listenToDocumentClicks();
        }, 0);

        return new Promise((resolve, reject) => {
            this.dialogRef.result.subscribe((result) => {
                const value = result instanceof DialogCloseResult ? ConfirmationDialogResult.Cancel : result['dialogResult'];

                resolve(value);
            });
        });
    }

    private isClickInsideDialog(target: Node): boolean {
        const dialogContainer = document.querySelector('.k-dialog');

        return dialogContainer && dialogContainer.contains(target);
    }

    closeDialog(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
            this.dialogRef = null;
        }
        this.destroyDocumentClickListener(); // Remove the listener
    }

    private listenToDocumentClicks(): void {
        if (!this.clickListener) {
            this.clickListener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
                const target = event.target as HTMLElement;
                if (this.dialogRef && !this.isClickInsideDialog(target)) {
                    this.closeDialog();
                }
            });
        }
    }

    private destroyDocumentClickListener(): void {
        if (this.clickListener) {
            this.clickListener(); // Call the listener reference to remove the event
            this.clickListener = null; // Reset the reference
        }
    }
}
